import styled                      from "styled-components";

import { NavBarVariants          } from "src/components/features/common/nav-bar";
import { ToolbarVariants         } from "src/components/features/main/common/toolbar";

import { themeColors,
         cssFlexColumn,
         cssFlexRow,
         cssFlexRowCC,           } from "src/providers/theme/shared";



export type ProductCounterLayout = {
  backgroundColor: string;

  paddings: number[];
  scrollableGap: number;
  addRollPadding: number;
  actionButtonPadding: number;
  layoutButtonPadding: number[];

  errorsIconColor: string;
  dividerColor: string;

  navbarVariant: NavBarVariants;
  toolbarVariant: ToolbarVariants;
  gap: number[];
  width: number; 
  height: number;
  iconWidth: number; 
  iconHeight: number;
  borderRadius: number;
  buttonLayoutMinWidth: number;
  selectProductMinHeight: number;
};

export const layout_light: ProductCounterLayout = {
  backgroundColor: themeColors.BackgroundFillLight,

  paddings: [16],
  scrollableGap: 8,
  addRollPadding: 20,
  actionButtonPadding: 20,
  layoutButtonPadding: [18, 16],

  errorsIconColor: themeColors.AccentRed1,
  dividerColor: themeColors.SecondaryGray3,

  navbarVariant: "lightblue",
  toolbarVariant: "light",

  gap: [12, 16], 
  width: 100,
  height: 100,
  iconWidth: 32,
  iconHeight: 32,
  borderRadius: 12,
  buttonLayoutMinWidth: 320,
  selectProductMinHeight: 38
};

export const layout_dark: ProductCounterLayout = {
  ...layout_light,
};

export const Screen = styled.div<{
  layout: ProductCounterLayout;
}>`
  width: ${(args) => args.layout.width}vw;
  height: ${(args) => args.layout.height}dvh;

  ${cssFlexColumn};

  background-color: ${(args) => args.layout.backgroundColor};
`;

export const ScreenBody = styled.div<{
  layout: ProductCounterLayout;
}>`
  ${cssFlexColumn};
  justify-content: space-between;
  flex-grow: 2;
  padding: ${(args) => args.layout.paddings[0]}px;
`;

export const ButtonLayout = styled.div<{
  layout: ProductCounterLayout;
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.layout.gap[1]}px;
  background-color: ${(args) => args.theme.color.SecondaryGray1};
  border-radius: ${(args) => args.layout.borderRadius}px;
  min-width: ${(args) => args.layout.buttonLayoutMinWidth}px;
  padding: ${(args) => args.layout.layoutButtonPadding[0]}px
    ${(args) => args.layout.layoutButtonPadding[1]}px;
`;

export const SelectedProduct = styled.div<{
  layout: ProductCounterLayout;
}>`
  ${cssFlexRow};
  min-height: ${(args) => args.layout.selectProductMinHeight}px;
  align-items: center;
  gap: ${(args) => args.layout.gap[0]}px;
  color: ${(args) => args.theme.color.AccentBlue2};
`;

export const IconContainer = styled.div<{
  layout: ProductCounterLayout;
}>`
  width: ${(args) => args.layout.iconWidth}px;
  height: ${(args) => args.layout.iconHeight}px;
  ${cssFlexRowCC};
`;

export const TitleContainer = styled.div`
  ${cssFlexColumn};
`;

export const ActionContainer = styled.div<{
  layout: ProductCounterLayout;
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.layout.gap[1]}px;
`;

export const ButtonContainer = styled.div<{
  layout: ProductCounterLayout;
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.layout.gap[0]}px;
`;
